module.exports = __webpack_public_path__ + "static/ui-unique-design-cccad5876e147cdbb40f162d05e76d85.png";